(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/play-single-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/play-single-page.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const {
  LOTTO_WEDNESDAY,
  LOTTO_SATURDAY
} = productMapping.CONSTANTS;
svs.lotto.views.PlaySinglePage = Marionette.View.extend({
  viewOptions: ['showDrawCount', 'showPlayTogether'],
  showDrawCount: true,
  showPlayTogether: true,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'play'
  }],
  regions: {
    rowsContainerRegion: '#ngRowsContainerRegion',
    betslipRegion: '#ngBetslipRegion',
    payfooterRegion: '#ngPayfooterRegion'
  },
  template(data) {
    return svs.lotto.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.lotto.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.LOTTO,
        boards: svs.core.detect.formfactor.desktop() ? svs.numbergames.rules.LOTTO.maxNumberOfRows : 1,
        jokerPrice: 10,
        rowPriceMulti: 2,
        jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow(),
        selectedDays: [LOTTO_WEDNESDAY, LOTTO_SATURDAY]
      }, {
        storageKey: 'single',
        parse: true,
        hasTickets: svs.lotto.data.hasTickets
      });
      this.showChildView('rowsContainerRegion', new svs.lotto.components.play.views.SingleRowsContainer({
        model
      }));
      this.showChildView('betslipRegion', new svs.lotto.components.play.views.Betslip({
        model,
        showDrawCount: this.showDrawCount,
        showPlayTogether: this.showPlayTogether
      }));
      let analyticsEvents;
      if (!svs.core.config.data.svsconfig.isSelfService) {
        const events = svs.numbergames.game.analytics_events;
        analyticsEvents = [events.BETROW_STARTED_COMPLETE, events.BETSLIP_COMPLETE];
      }
      this.showChildView('payfooterRegion', new svs.lotto.components.play.views.Payfooter({
        model,
        analyticsEvents
      }));
    }
  }
});

 })(window);